import React from 'react'
import { Box } from '@chatterbug/aaron'
import { LeaderboardPosition } from 'src/types'
import RedactedUsers from '../RedactedUsers/RedactedUsers'
import LeaderboardRow from '../LeaderboardRow/LeaderboardRow'

export type Props = {
  topUsers: LeaderboardPosition[]
  orgSize: number
  currenutUserId: number
}

const UserIsOnTop: React.FC<Props> = ({
  topUsers,
  orgSize,
  currenutUserId,
}) => {
  return (
    <Box>
      {topUsers.map((item, index) => {
        const isCurrentUser = item.user.id === currenutUserId && item.rank !== 1
        return (
          <LeaderboardRow
            key={`leaderboard-row-${index}`}
            {...item}
            isCurrentUser={isCurrentUser}
          />
        )
      })}
      {/* to safeguard against the case when the org is smaller than 3 members (we have such case) */}
      {orgSize > 3 && (
        <Box mt="2x">
          <RedactedUsers redactedNum={orgSize - 3} />
        </Box>
      )}
    </Box>
  )
}

export default UserIsOnTop
